<div class="admin-content-container">
  <div class="admin-content-container-overlay"></div>
  <div class="container admin-container" *ngIf="currentUser; else loggedOut">
    <div class="row">
      <div class="col-lg-12">
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <ng-container *ngIf="isSuperAdmin || isAdmin">
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/users']" routerLinkActive="active">Users
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/customers']" routerLinkActive="active">Customers
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/offices']" routerLinkActive="active">Offices
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/subscriptions']" routerLinkActive="active">Subscriptions
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/subscription-coupons']" routerLinkActive="active">Subscription Coupons
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/rooms']" routerLinkActive="active">Rooms
              </button>
            </ng-container>
            <ng-container *ngIf="isSuperAdmin">
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/workplaces']" routerLinkActive="active">Workplaces
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/doors']" routerLinkActive="active">Doors
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/timeperiods']" routerLinkActive="active">Time Periods
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/prices']" routerLinkActive="active">Booking Prices
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/office-coupons']" routerLinkActive="active">Office Coupons
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/zk/users']" routerLinkActive="active">ZkTeco Users
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/zk/logs']" routerLinkActive="active">ZkTeco RT Log
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/relayboards']" routerLinkActive="active">Relay Boards
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/relays']" routerLinkActive="active">Relays
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/sensors']" routerLinkActive="active">Sensors
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/relayscriptrules']" routerLinkActive="active">Relay Script
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/usernotifications']" routerLinkActive="active">User Notifications
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/policies']" routerLinkActive="active">Policy Management
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/visitors']" routerLinkActive="active">Visitors
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/quickcards']" routerLinkActive="active">Quick Cards
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/coffeeconfigs']" routerLinkActive="active">Coffee Configs
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/roomclosures']" routerLinkActive="active">Room Closures
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/discounts']" routerLinkActive="active">Discounts
              </button>
              <button class="nav-link" type="button"
                      [routerLink]="['/admin/orders']" routerLinkActive="active">Orders
              </button>
            </ng-container>

            <button class="nav-link" type="button"
                    [routerLink]="['/admin/lessons-schedule']" routerLinkActive="active">Lessons Schedule
            </button>
            <button class="nav-link" type="button"
                    [routerLink]="['/admin/booked-lessons']" routerLinkActive="active">Booked Lessons
            </button>
          </div>
        </nav>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <ng-template #loggedOut> Please login.</ng-template>
</div>
